import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {AppComponent} from './app.component';
import {AppRoutingModule} from './app-routing.module';
import {LoginComponent} from './login/login.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {BootstrapPaginationComponent} from './bootstrap-pagination/bootstrap-pagination.component';
import {NgxPaginationModule} from 'ngx-pagination';
import * as moment from 'moment';
import 'moment/locale/da';
import {DashboardComponent} from './dashboard/dashboard.component';
import {environment} from '../environments/environment';
import {AuthGuard, AuthService, HitCommonModule, UsersService} from '@hassel-it/angular-common';
import {DateTimePickerComponent} from './date-time-picker/date-time-picker.component';
import {TimeagoCustomFormatter, TimeagoFormatter, TimeagoIntl, TimeagoModule} from 'ngx-timeago';
import {RouterModalComponent} from './router-modal/router-modal.component';
import {MomentModule} from 'ngx-moment';
import {SearchDebuggerComponent} from './search-debugger/search-debugger.component';
import {MonitorsComponent} from './monitors/monitors.component';
import {ShippingSystemComponent} from './shipping-system/shipping-system.component';
import {ShippingMissingCoordinatesComponent} from './shipping-missing-coordinates/shipping-missing-coordinates.component';
import {ShipmentEditModalComponent} from './shipment-edit-modal/shipment-edit-modal.component';
import {ShippingSystemTableComponent} from './shipping-system-table/shipping-system-table.component';
import {ShippingSystemSorterComponent} from './shipping-system-sorter/shipping-system-sorter.component';
import {ShipmentDetailsPopupComponent} from './shipment-details-popup/shipment-details-popup.component';
import ShipmentEditFormComponent from './shipment-edit-form/shipment-edit-form.component';
import {SafeEmbeddedImagePipe} from './pipes/safe-embedded-image-pipe';
import {ShipmentStatusWidgetComponent} from './shipment-status-widget/shipment-status-widget.component';
import {LightboxModule} from 'ngx-lightbox';
import {NotificationsService} from './services/notifications.service';
import {ShippingPricelistsService} from './services/shipping-pricelists.service';
import {ShipmentsService} from './services/shipments.service';
import {ShipmentRoutesService} from './services/shipment-routes.service';
import {ShipmentProductLineComponent} from './shipment-product-line/shipment-product-line.component';
import {ShipmentRoutesComponent} from './shipment-routes/shipment-routes.component';
import {ShipmentDriversComponent} from './shipment-drivers/shipment-drivers.component';
import {ShipmentDriverDetailComponent} from './shipment-driver-detail/shipment-driver-detail.component';
import {ShipmentrouteDetailComponent} from './shipment-route-detail/shipment-route-detail.component';
import { ShipmentSystemSubmenuComponent } from './shipment-system-submenu/shipment-system-submenu.component';
import {HttpClientModule} from '@angular/common/http';
import {SortablejsModule} from 'ngx-sortablejs';
import { PickerQueueComponent } from './picker-queue/picker-queue.component';
import '@angular/common/locales/global/da';
import {PriceRobotProductsComponent} from './price-robot-products/price-robot-products.component';
import {PriceRobotPaginationComponent} from './price-robot-pagination/price-robot-pagination.component';
import {PriceRobotFilterBoxComponent} from './price-robot-filter-box/price-robot-filter-box.component';
import {PriceRobotCompetitorsComponent} from './price-robot-competitors/price-robot-competitors.component';
import {PriceRobotCompetitorComponent} from './price-robot-competitor/price-robot-competitor.component';
import {PriceRobotRulesListComponent} from './price-robot-rules-list/price-robot-rules-list.component';
import {PriceRobotRulesComponent} from './price-robot-rules/price-robot-rules.component';
import {PriceRobotProductComponent} from './price-robot-product/price-robot-product.component';
import {NgChartsModule} from 'ng2-charts';
import {SpinnerComponent} from './spinner/spinner.component';
import {SortByPipe} from './pipes/sort-by-pipe';
import {ShipmentStatsComponent} from './shipment-stats/shipment-stats.component';
import { PriceRobotSubmenuComponent } from './price-robot-submenu/price-robot-submenu.component';
import {ShopServicesModule} from '@hassel-it/shop-services';
import {MessageViewComponent} from './message-view/message-view.component';
import * as dayjs from 'dayjs';
import {MultiselectDropdownModule} from 'angular-2-dropdown-multiselect';
import {NgMultiSelectDropDownModule} from 'ng-multiselect-dropdown';
import {UserManagerComponent} from './user-manager/user-manager.component';
import {UserEditComponent} from './user-edit/user-edit.component';
import {ShipmentEventModalComponent} from './shipment-event-modal/shipment-event-modal.component';
import { ShipmentsControlComponent } from './shipments-control/shipments-control.component';
import { ShipmentHelpComponent } from './shipment-help/shipment-help.component';
import { MainNavigationComponent } from './main-navigation/main-navigation.component';
import { PriceGraphsComponent } from './price-graphs/price-graphs.component';
import {SafeResourceUrlPipe} from './pipes/safe-url-pipe';
import { PriceRobotProductRowComponent } from './price-robot/widgets/price-robot-product-row/price-robot-product-row.component';
import { PriceRobotProductHeaderComponent } from './price-robot/widgets/price-robot-product-header/price-robot-product-header.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { PriceRobotErrorDisplayComponent } from './price-robot/widgets/price-robot-error-display/price-robot-error-display.component';
import {ShipmentStateComponent} from './shipment-state/shipment-state.component';
import {ShipmentDiagramComponent} from './shipment-diagram/shipment-diagram.component';
import {ShipmentDetailsPopupModalComponent} from './shipment-details-popup-modal/shipment-details-popup-modal.component';
import {ShipmentPackageAddModalComponent} from './shipment-package-add-modal/shipment-package-add-modal.component';
import { ShipmendAdressComponent } from './shipmend-adress/shipmend-adress.component';
import {DragulaModule} from 'ng2-dragula';
import { MapComponent } from './map/map.component';
import {NewlineToBrPipe} from '../newline_to_br_pipe';
import {MetaFilterPipeAlt} from './pipes/filter-pipe';
import { ShipmentDetailsComponent } from './shipment-details/shipment-details.component';
import { DriverStatusModalComponent } from './driver-status-modal/driver-status-modal.component';
import { EventForwardModalComponent } from './event-forward-modal/event-forward-modal.component';
import {ShipmentProductLineModalComponent} from './shipment-product-line-modal/shipment-event-modal.component';
import {PreventNegativeDecimalDirective} from './shipment-product-line-modal/PreventNegativeDecimalInputDirective';
import { EditAdressesFormComponent } from './edit-adresses-form/edit-adresses-form.component';
import { ShipmentUtilitiesComponent } from './shipment-utilities/shipment-utilities.component';
import { PriceRobotDashboardComponent } from './price-robot-dashboard/price-robot-dashboard.component';
import { PickingListComponent } from './picking-list/picking-list.component';
import {ShipmentSystemSimplenavComponent} from './shipment-system-simplenav/shipment-system-simplenav.component';
import {ShipmentAddressPickerComponent} from './shipment-address-picker/shipment-address-picker.component';
import { ShipmentPackagingInfoComponent } from './shipment-packaging-info/shipment-packaging-info.component';
import { ControlDashboardComponent } from './control-dashboard/control-dashboard.component';
import { NumberInputComponent } from './number-input/number-input.component';
import { NotificationsComponent } from './notifications/notifications.component';
import { DgBadgesComponent } from './dg-badges/dg-badges.component';
import { PickingListActionsComponent } from './picking-list-actions/picking-list-actions.component';
import { PickingListsComponent } from './picking-lists/picking-lists.component';
import { PickingListStatusComponent } from './picking-list-status/picking-list-status.component';
import { PickingListMenuComponent } from './picking-list-menu/picking-list-menu.component';
import { ShipmentsModalComponent } from './shipments-modal/shipments-modal.component';

moment.locale('da');
moment.fn.toJSON = function () {
    return this.format();
};

dayjs.prototype.toJSON = function () {
    return this.format('YYYY-MM-DDTHH:mm:ssZ');
};


export class MyIntl extends TimeagoIntl {
// do extra stuff here...
}

@NgModule({
    providers: [
        NotificationsService,
        ShippingPricelistsService,
        ShipmentsService,
        ShipmentRoutesService,
        UsersService,
        AuthGuard,
        AuthService
    ],
    imports: [
        MultiselectDropdownModule,
        MomentModule,
        ReactiveFormsModule,
        BrowserModule,
        FormsModule,
        HttpClientModule,
        NgbModule,
        AppRoutingModule,
        NgxPaginationModule,
        ShopServicesModule,
        HitCommonModule.forRoot({
            apiBase: environment.apiBase,
            production: environment.production,
        }),
        TimeagoModule.forRoot({
            intl: {provide: TimeagoIntl, useClass: MyIntl},
            formatter: {provide: TimeagoFormatter, useClass: TimeagoCustomFormatter},
        }),
        SortablejsModule.forRoot({animation: 150}),
        LightboxModule,
        NgChartsModule,
        NgMultiSelectDropDownModule.forRoot(),
        FontAwesomeModule,
        DragulaModule.forRoot(),
        NewlineToBrPipe,
        MetaFilterPipeAlt,
        PreventNegativeDecimalDirective
    ],
    declarations: [
        DateTimePickerComponent,
        AppComponent,
        LoginComponent,
        BootstrapPaginationComponent,
        DashboardComponent,
        ShipmentStatsComponent,
        RouterModalComponent,
        ShipmentPackageAddModalComponent,
        SearchDebuggerComponent,
        MonitorsComponent,
        ShippingSystemComponent,
        ShippingMissingCoordinatesComponent,
        ShipmentEditModalComponent,
        ShippingSystemSorterComponent,
        ShippingSystemTableComponent,
        ShipmentEditModalComponent,
        ShipmentDetailsPopupComponent,
        ShipmentEditFormComponent,
        SafeEmbeddedImagePipe,
        SafeResourceUrlPipe,
        ShipmentStateComponent,
        SortByPipe,
        ShipmentStatusWidgetComponent,
        ShipmentProductLineComponent,
        ShipmentProductLineModalComponent,
        ShipmentRoutesComponent,
        ShipmentDriversComponent,
        ShipmentDriverDetailComponent,
        ShipmentrouteDetailComponent,
        ShipmentSystemSubmenuComponent,
        PickerQueueComponent,
        PriceRobotProductsComponent,
        PriceRobotPaginationComponent,
        PriceRobotFilterBoxComponent,
        PriceRobotCompetitorsComponent,
        PriceRobotCompetitorComponent,
        PriceRobotRulesListComponent,
        PriceRobotRulesComponent,
        PriceRobotProductComponent,
        SpinnerComponent,
        PriceRobotSubmenuComponent,
        MessageViewComponent,
        UserManagerComponent,
        UserEditComponent,
        ShipmentEventModalComponent,
        ShipmentsControlComponent,
        ShipmentHelpComponent,
        MainNavigationComponent,
        PriceGraphsComponent,
        PriceRobotProductRowComponent,
        ShipmentDiagramComponent,
        PriceRobotProductHeaderComponent,
        PriceRobotErrorDisplayComponent,
        ShipmentDetailsPopupModalComponent,
        ShipmendAdressComponent,
        MapComponent,
        ShipmentDetailsComponent,
        DriverStatusModalComponent,
        EventForwardModalComponent,
        EditAdressesFormComponent,
        ShipmentUtilitiesComponent,
        PriceRobotDashboardComponent,
        PickingListComponent,
        ShipmentSystemSimplenavComponent,
        ShipmentAddressPickerComponent,
        ShipmentPackagingInfoComponent,
        ControlDashboardComponent,
        NumberInputComponent,
        NotificationsComponent,
        DgBadgesComponent,
        PickingListActionsComponent,
        PickingListsComponent,
        PickingListStatusComponent,
        PickingListMenuComponent,
        ShipmentsModalComponent
    ],
    bootstrap: [
        AppComponent
    ]
})
export class AppModule {
}
